import * as moment from "moment";

export function isPaymentActive(startDate: string, endDate: string) {
  if (!startDate || !endDate) {
    return null;
  }
  const currentDate = moment();
  const start = moment(startDate);
  const end = moment(endDate);

  return currentDate.isBetween(start, end, null, "[]");
}

export const countActiveContracts = (payments: any) => {
  let activeContractsCount = 0;

  if (payments && Array.isArray(payments)) {
    payments.forEach((payment) => {
      const { startDate, endDate } = payment;

      if (isPaymentActive(startDate, endDate)) {
        activeContractsCount += 1;
      }
    });
  }

  return activeContractsCount;
};
